var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 55",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "018---Astronaut",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m17 9.00000869-9.79-.00000869c-.20185437.00118573-.38462264-.11912041-.46334587-.30499469-.07872322-.18587428-.03795811-.40085338.10334587-.54500531l2.8-2.8c.19057144-.19442176.19057144-.50557824 0-.7l-2.8-2.8c-.14130398-.14415193-.18206909-.35913103-.10334587-.54500531.07872323-.18587428.2614915-.30618042.46334587-.30499469l9.79-.00000869z",
    fill: "#26b99a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m17 14c-.5522847 0-1-.4477153-1-1v-12c0-.55228475.4477153-1 1-1s1 .44771525 1 1v12c0 .5522847-.4477153 1-1 1z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m45.43 29.9c5.27 3.88 9.2 9.46 5.11 14.38-3.61 4.32-8.48 4-12.7.37l2.31-3.31c1.1408757 1.1666469 2.6487873 1.9047114 4.27 2.09 1.2072066-.0867748 2.3102058-.7154843 3-1.71.6004106-.6360177.8638159-1.518982.71-2.38-.31-1.99-3.13-4.78-5.13-6.34z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m19.88 39.63c-2.19-1-6.47-1.7-11.38 1.37l-1.06.64c-.71670809.4310895-1.58083773.5434194-2.38394054.3098931-.80310281-.2335264-1.47226157-.7917061-1.84605946-1.5398931l-2.84-5.66c-.24843286-.5031975-.27402788-1.0876194-.07053735-1.6106091s.61734329-.9364264 1.14053735-1.1393909c4.5-1.66 6.06 3 6.06 3 3.9576172-3.5825385 9.4412495-4.9553219 14.62-3.66l.88 7.66z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 43.48 2.27 1.14c.7271205.3643008 1.5709895.4177824 2.3382839.1481925.7672943-.2695899 1.3922576-.8391477 1.7317161-1.5781925l9.37-20.39c.334848-.7335774.3602752-1.5710705.0705472-2.3236107-.2897279-.7525402-.8702134-1.3567569-1.6105472-1.6763893l-4.17-1.8z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 19-7.36 1.56-3-5.9c-.7850281-1.393258-2.5249413-1.9258001-3.9553083-1.2106166s-2.0482813 2.4266393-1.4046917 3.8906166l4 8c.513571 1.0289186 1.5701129 1.6737199 2.72 1.66 1.0441829-.1018619 2.0758156-.3061788 3.08-.61z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42.82 20.63c.12.08-.33-.29 3 2.45.6863741.5869041 1.605689.8231939 2.49.64.26 0 .71-.24 5.28-2.35 1.4445052-.7309425 3.2084095-.183946 3.9858971 1.2360487.7774877 1.4199948.288088 3.2007395-1.1058971 4.0239513l-4.47 2.05c-3.2144571 1.7487883-7.1677439 1.3771793-10-.94-2.17 2.38-4.5 5.69-5 9.26-.58 4.07-2.52 5.77-4 6.48-.6256324.3041233-1.3054666.4808802-2 .52 0 0-8.5 0-11 7l-.49 1.14c-.3321359.768585-.9703531 1.3633994-1.7603893 1.6406717s-1.6599987.211771-2.3996107-.1806717l-5.6-3c-.49554453-.261276-.85879337-.7184081-1.00136177-1.260168-.14256839-.5417599-.05138569-1.1184791.25136177-1.589832 2.73-4.31 7-.75 7-.75 1-6 4.93-8.23 4.93-8.23-.16-6.39 3.47-13.93 7-19.27z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 12c0 6.0751322-4.9248678 11-11 11s-11-4.9248678-11-11c0-6.07513225 4.9248678-11 11-11s11 4.92486775 11 11z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 11c-.5399341 5.6435533-5.2806771 9.9523837-10.95 9.9523837s-10.4100659-4.3088304-10.95-9.9523837c.5399341-5.64355329 5.2806771-9.95238366 10.95-9.95238366s10.4100659 4.30883037 10.95 9.95238366z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f0c419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 24c-.55228475 0-1-.4477153-1-1v-4c0-.5522847.44771525-1 1-1s1 .4477153 1 1v4c0 .5522847-.44771525 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m8 22h-4c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h4c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m31 55c-.5522847 0-1-.4477153-1-1v-4c0-.5522847.4477153-1 1-1s1 .4477153 1 1v4c0 .5522847-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 53h-4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52 6c-.5522847 0-1-.44771525-1-1v-4c0-.55228475.4477153-1 1-1s1 .44771525 1 1v4c0 .55228475-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 4h-4c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1h4c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 12c0 5.95-9.47 9.18-15.61 5.35-1.8515714-3.3263641-1.8515714-7.3736359 0-10.7 6.06-3.82 15.61-.65 15.61 5.35z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28 13c-.5522847 0-1-.4477153-1-1 0-4 3.92-5 6-5 .5522847 0 1 .44771525 1 1s-.4477153 1-1 1c-.18 0-4 .06-4 3 0 .5522847-.4477153 1-1 1z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 12c0 5.95-9.47 9.18-15.61 5.35-.613935-1.0891561-1.0335349-2.2768945-1.24-3.51 3.68 1.58 10 2.52 15.64-5.26.7702983.9749008 1.1958101 2.1775872 1.21 3.42z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m9.92 40.2c-.73.37-.88.47-2.48 1.44-.71670809.4310895-1.58083773.5434194-2.38394054.3098931-.80310281-.2335264-1.47226157-.7917061-1.84605946-1.5398931l-2.84-5.66c-.24843286-.5031975-.27402788-1.0876194-.07053735-1.6106091s.61734329-.9364264 1.14053735-1.1393909c4.5-1.66 6.06 3 6.06 3z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m20.62 49.63c-.35.62-.35.76-1.1 2.48-.3321359.768585-.9703531 1.3633994-1.7603893 1.6406717s-1.6599987.211771-2.3996107-.1806717l-5.6-3c-.48858329-.2599772-.84759586-.7107892-.99161288-1.2451682-.14401702-.5343789-.06016178-1.1045454.23161288-1.5748318 2.73-4.31 7-.75 7-.75z",
    fill: "#35495e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.c2fa18b01370df821f3274c3e39a9f0c.svg";
export { ForwardRef as ReactComponent };